import tw from 'twin.macro'
import styled from 'styled-components'

export const FormattedEmbed = styled.embed`
  ${tw`hidden lg:block lg:[height:40rem] xl:[height:50rem] max-h-screen`}
`
